import React from "react";
import { Link } from 'react-scroll';
import './home.css';
import { useTypewriter, Cursor} from 'react-simple-typewriter';
import Ruhani from '../../assets/ruhani.jpg';
import Arrow from '../../assets/arrow.png';

const Home = () => {
    const [text] = useTypewriter({
        words: ['Hello!', 'Namaste!', '¡Hola!', 'Bonjour!'],
        loop: {},
        typeSpeed: 120, 
        deleteSpeed: 80,
    });

    return (
        <section id="Home">
            <div className="home-container">
                <div className="intro">
                    <span className="hello">
                        {text}
                        <Cursor/>
                    </span>
                    <span className="introText">I'm <span className="introName">Ruhani Mittal</span></span>
                    <span className="subtext2">
                    You've landed on my little corner of the web where I share my journey as a third-year Computer Science 👩🏻‍💻 student passionate about data analysis and full-stack development. I love exploring how data can drive smarter decisions 📊 and how thoughtful code can bring powerful ideas to life 💻. Whether it's building responsive web apps or extracting insights from datasets, I'm always learning and looking for meaningful ways to grow. Let's connect and see what amazing things we can create together!
                    </span>
                    <span className="subtext3">
                    <Link 
                        to="Projects" 
                        smooth={true}
                        offset={-80} 
                        duration={1000} // 1000ms = 1 second
                        className="subtext3"
                        >
                        {/* <img src={Arrow} alt="arrow" className="arrow" /> */}
                        <span className="view">View Projects</span>
                        </Link>
                    </span>
                </div>
                </div>
        </section>
    );
}

export default Home;